import { render, staticRenderFns } from "./estadisticaDashboard.vue?vue&type=template&id=4024797a&scoped=true"
import script from "./estadisticaDashboard.vue?vue&type=script&lang=js"
export * from "./estadisticaDashboard.vue?vue&type=script&lang=js"
import style0 from "./estadisticaDashboard.vue?vue&type=style&index=0&id=4024797a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024797a",
  null
  
)

export default component.exports